import {Component, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-filter-bar',
    templateUrl: './app-filter-bar.component.html',
    styleUrls: ['./app-filter-bar.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class AppFilterBarComponent {
    searchColClass = input<string>('col-xs-12 col-sm-5');
    actionsColClass = input<string>('col-xs-12 col-sm-7');
}
